import './multiselect.scss';
class Multiselect {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-multiselect',
            activeAttr: 'data-multiselect-active',
            selectBoxValue: 'select-box',
            fakeOptionsValue: 'fake-options',
            fakeOptionValue: 'fake-option',
            selectedItemsValue: 'selected-items',
            singleCountLabelAttr: 'data-single-count-label',
            multipleCountLabelAttr: 'data-multiple-count-label',
            toggleAllValue: 'toggle-all'
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$selectBox = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.selectBoxValue}"]`);
        this.$fakeOptionWrapper = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.fakeOptionsValue}"]`);
        this.$$fakeOptions = this.$fakeOptionWrapper?.querySelectorAll(`[${this.settings.initAttr}="${this.settings.fakeOptionValue}"]`);
        this.$selectedItems = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.selectedItemsValue}"]`);
        this.$$selectedValues = [];
        this.$toggleAll = this.$root.querySelector(`[${this.settings.initAttr}-name="${this.settings.toggleAllValue}"]`);

        // States & options
        this.multibleOptions = this.$root.dataset.multibleOptions;
        this.disabledState = this.$root.dataset.disabledState;
        this.hideSelected = this.$root.dataset.hideSelected;
        this.autoCloseOnChange = this.$root.dataset.autoCloseOnChange;
        this.emptyLabel = this.$selectedItems?.textContent;
        this.checkedOptions = 0;
        this.singleCountLabel = this.$root.getAttribute(this.settings.singleCountLabelAttr);
        this.multipleCountLabel = this.$root.getAttribute(this.settings.multipleCountLabelAttr);
        this.deselectable = this.checkedOptions === this.$$fakeOptions.length;
    }

    initialize () {
        this.initCheckForSelected();
        this.setEvents();
    }

    updatePlaceholder () {
        let placeholderText = this.emptyLabel;

        if (this.checkedOptions === 1) {
            placeholderText = `${this.checkedOptions} ${this.singleCountLabel}`;
        } else if (this.checkedOptions > 1) {
            placeholderText = `${this.checkedOptions} ${this.multipleCountLabel}`;
        }

        this.$selectedItems.textContent = placeholderText;

        if (this.checkedOptions > 0) {
            this.$selectedItems.classList.remove('select-box__selected-items--disabled');
        } else {
            this.$selectedItems.classList.add('select-box__selected-items--disabled');
        }
    }

    initCheckForSelected () {
        this.$$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="checkbox"]');
            if ($checkbox.checked) {
                this.updateSelectedItems($checkbox, false);
            }
        });
    }

    autoClose () {
        this.$fakeOptionWrapper.setAttribute('aria-hidden', true);
        this.$root.setAttribute(this.settings.activeAttr, false);
        this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaClosed);
    }

    clearOptionsExceptCurrent ($currentCheckbox) {
        this.$$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="checkbox"]');
            if ($checkbox !== $currentCheckbox) {
                $checkbox.checked = false;
                this.updateSelectedItems($checkbox);
            }
        });
    }

    toggleOptions () {
        const expanded = this.$root.getAttribute(this.settings.activeAttr) === 'true';
        this.$fakeOptionWrapper.setAttribute('aria-hidden', expanded);
        this.$root.setAttribute(this.settings.activeAttr, !expanded);

        if (!expanded) {
            this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaOpen);
        } else {
            this.$selectBox.setAttribute('aria-label', this.$selectBox.dataset.ariaClosed);
        }
    }

    updateSelectedItems ($checkbox, ignore) {
        const $checkboxValue = $checkbox.value;
        const $checkboxLabel = $checkbox.parentNode.textContent.trim();
        const $selectOption = this.$root.querySelector(`option[value="${$checkboxValue}"]`);

        if ($checkbox.checked) {
            $selectOption.selected = true;
            this.$$selectedValues.push($checkboxLabel);
            $checkbox.parentNode.classList.add('select-box__fake-option--active');
            $checkbox.parentNode.setAttribute('aria-checked', true);

            if ($checkbox !== this.$toggleAll) {
                this.checkedOptions++;
            }
        } else {
            $selectOption.selected = false;
            this.$$selectedValues = this.$$selectedValues.filter(value => value !== $checkboxLabel);

            $checkbox.parentNode.classList.remove('select-box__fake-option--active');
            $checkbox.parentNode.setAttribute('aria-checked', false);

            if ($checkbox !== this.$toggleAll) {
                this.checkedOptions--;
            }
        }

        this.deselectable = this.checkedOptions === this.$$fakeOptions.length - 1;

        if (this.hideSelected === 'false') {
            this.$selectedItems.textContent = this.$$selectedValues.join(', ') || this.$selectedItems.dataset.placeholder;
        }

        if (this.autoCloseOnChange === 'true') {
            this.autoClose();
        }

        if (!ignore) {
            if (this.$toggleAll !== $checkbox) {
                // If the current checkbox is not the toggle all
                // Set all to selected if all selected is pressed
                this.$toggleAll.checked = true;
                this.updateSelectedItems(this.$toggleAll, true);

                if (!this.deselectable && this.$toggleAll.checked) {
                    this.$toggleAll.checked = false;
                    this.updateSelectedItems(this.$toggleAll, true);
                }
            } else {
                // If the current checkbox is the toggle all
                // Deselect all
                if (this.checkedOptions === this.$$fakeOptions.length - 1 && this.deselectable) {
                    this.$$fakeOptions.forEach($fakeOption => {
                        const $originalCheckbox = $fakeOption.querySelector('input[type="checkbox"]');

                        if ($originalCheckbox.checked) {
                            $originalCheckbox.checked = false;
                            this.updateSelectedItems($originalCheckbox, true);
                        }
                    });
                } else {
                    this.$$fakeOptions.forEach($fakeOption => {
                        const $originalCheckbox = $fakeOption.querySelector('input[type="checkbox"]');

                        if (!$originalCheckbox.checked) {
                            $originalCheckbox.checked = true;
                            this.updateSelectedItems($originalCheckbox, true);
                        }
                    });
                }
            }
        }
    }

    handleOutsideClick (e) {
        if (!this.$root.contains(e.target)) {
            this.autoClose();
        }
    }

    toggleAllSelect () {

    }

    setEvents () {
        this.$selectBox.onclick = () => {
            if (this.disabledState === 'false') {
                this.toggleOptions();
            }
        };

        this.$selectBox.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                event.preventDefault();

                if (this.disabledState === 'false') {
                    this.toggleOptions();
                }
            }
        });

        this.$selectBox.addEventListener('keydown', (event) => {
            if (event.code === 'Escape') {
                event.preventDefault();
                this.toggleOptions();
            }
        });

        this.$$fakeOptions.forEach($fakeOption => {
            const $checkbox = $fakeOption.querySelector('input[type="checkbox"]');

            $fakeOption.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    $checkbox.checked = !$checkbox.checked;
                    this.updateSelectedItems($checkbox);

                    if (this.multibleOptions === 'false') {
                        this.clearOptionsExceptCurrent($checkbox);
                    }

                    if (this.singleCountLabel !== null && this.multipleCountLabel !== null) {
                        this.updatePlaceholder();
                    }
                }
            });

            $checkbox.addEventListener('change', () => {
                this.updateSelectedItems($checkbox);

                if (this.multibleOptions === 'false') {
                    this.clearOptionsExceptCurrent($checkbox);
                }

                if (this.singleCountLabel !== null && this.multipleCountLabel !== null) {
                    this.updatePlaceholder();
                }
            });
        });

        document.addEventListener('click', (e) => {
            this.handleOutsideClick(e);
        });

        document.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' || event.code === 'Tabs') {
                this.handleOutsideClick(event);
            }
        });

        window.addEventListener('select.options.rerender', () => {
            this.$$fakeOptions = [];
            this.$$fakeOptions = this.$fakeOptionWrapper.querySelectorAll('[data-multiselect="fake-option"]');
        });
    }
}

export { Multiselect };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-multiselect="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new Multiselect($root);
            $rootAPI.initialize();
        });
    }
});
